/* eslint-disable camelcase */
/* eslint-disable react/prop-types */
import React, { useState } from 'react'
import {
  Box, Button, Paper, Typography,
} from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import 'dayjs/locale/id'
// import icons from '@assets/icons'
import images from '@assets/images'
// import { matchDomain } from '@config/helpers'
import application from '@config/application'
import useStyles from './styles-jss/registerPayment-jss'
import PaymentConfirmationDialog from './PaymentConfirmationDialog'

const RegisterPayment = ({ location }) => {
  const classes = useStyles()
  const history = useHistory()
  const {
    price, banks, customer_id, registration_payment_id, paymentUrl,
  } = location.state
  const [paymentConfirmation, setPaymentConfirmation] = useState(false)
  const renderActivePayment = () => (
    <div className={classes.wrapper}>
      <Paper className={classes.paper}>
        {/* {
          matchDomain(window.location.hostname)
          && (
          <img
            src={icons.AppLogo}
            height={138}
            width={110}
            alt="logo"
            className={classes.logo}
          />
          )
        } */}
        <div style={{ width: 110, height: 138 }} />

        <Typography
          variant="h6"
          className={classes.title}
          gutterBottom
        >
          Terima kasih telah melakukan registrasi
        </Typography>

        <Typography
          variant="body2"
          className={classes.txDescription}
          gutterBottom
        >
          Silahkan lakukan pembayaran untuk menyelesaikan proses registrasi, dan transfer sejumlah:
        </Typography>

        <Typography
          variant="body2"
          className={classes.price}
          gutterBottom
        >
          {price}
        </Typography>

        <Paper className={classes.info}>
          <strong>Penting! </strong>
          Mohon transfer sesuai sampai dengan 3 digit terakhir
        </Paper>
        <Typography variant="caption" gutterBottom>
          Silahkan Transfer ke salah satu bank berikut:
        </Typography>

        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
        >
          {
            banks.map((item) => (
              <Box display="flex" alignItems="flex-start" key={item.bank_name}>
                <Box margin={2}>
                  <img
                    src={images[item.bank_code]}
                    alt={item.code}
                    height={32}
                    width={64}
                  />
                </Box>
                <Box margin={2} display="flex" flexDirection="column" flex={1}>
                  <Typography
                    style={{
                      fontSize: 16,
                      fontWeight: 'bold',
                      color: '#1C1977',
                    }}
                  >
                    {item.bank_code}
                  </Typography>
                  <Typography style={{ fontSize: 14 }}>
                    {item.account_holder_name}
                  </Typography>
                  <Typography style={{ fontSize: 14 }}>
                    {item.bank_account_number}
                  </Typography>
                </Box>
              </Box>
            ))
          }
        </Box>
        {paymentUrl
        && (
        <Button
          color="primary"
          style={{ marginTop: 16, minWidth: 250 }}
          variant="contained"
          onClick={() => window.open(paymentUrl)}
        >
          Proses Pembayaran
        </Button>
        )}
        {!paymentUrl && customer_id && registration_payment_id && (
        <Button
          color="primary"
          style={{ marginTop: 16, minWidth: 250 }}
          variant="contained"
          onClick={() => setPaymentConfirmation(true)}
        >
          Upload Bukti Pembayaran
        </Button>
        )}
        {paymentConfirmation && (
        <PaymentConfirmationDialog
          open={paymentConfirmation}
          onClose={() => {
            setPaymentConfirmation(false)
            setTimeout(() => {
              history.push(`${application.prefix}/login`)
            }, 1000)
          }}
          data={{
            customer_id,
            registration_payment: {
              id: registration_payment_id,
            },
          }}
        />
        )}
        <Button
          color="secondary"
          style={{ marginTop: 16, minWidth: 250 }}
          variant="contained"
          onClick={() => history.goBack()}
        >
          Kembali ke halaman awal
        </Button>
      </Paper>
    </div>
  )

  return (
    <Box className={classes.root}>
      <Helmet>
        <title>Squids Payment</title>
      </Helmet>
      {renderActivePayment()}
    </Box>
  )
}

export default RegisterPayment
